<template>
  <!-- Tab -->
  <div class="table-tabs mb-5">
    <div
      class="tab pa-10px"
      :class="{ active: currentBuTabId === '' }"
      @click="setCurrentBuTabId('')"
    >
      All
    </div>
    <div
      class="tab pa-10px"
      :class="{ active: tab.id === currentBuTabId }"
      v-for="(tab) in buTabs"
      :key="tab.id"
      @click="setCurrentBuTabId(tab.id)"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['currentBuTabId', 'buTabs']),
  },
  created() {
    this.setCurrentBuTabId('');
  },
  methods: {
    ...mapActions(['setCurrentBuTabId']),
  },
};
</script>

<style lang="scss"></style>
